import Navigation from './Navigation'
import Footer from './Footer'
import React from "react";

export default function Layout({children, showAdminNavigation = false}) {
    return (
        <>
            {showAdminNavigation && <Navigation/>}
            <main className='main-block'>
                <div className='container'>
                    {children}
                </div>
            </main>

            <div className="bottom-block-container">
                <div className="footer-program-left-block">
                    <div className="footer-program-project-icons">
                        <div className="footer-program-project-icon">
                            <img
                                src='/img/communitism_logo_transparent_black.png'
                                className='footer-project-logo'
                                alt='communitism logo'
                            />
                        </div>
                        {/*<div className="footer-program-project-icon">*/}
                        {/*    <img*/}
                        {/*        src='/img/heriscope_LOGO-03.png'*/}
                        {/*        className='footer-project-logo'*/}
                        {/*        alt='heriscope logo'*/}
                        {/*    />*/}
                        {/*</div>*/}
                    </div>
                    <nav className="footer-links">
                        <a href="/map">Χάρτης Μεταξουργείου</a>
                        <a href="/about">Σχετικά με εμάς</a>
                        <a href="/participate">Πώς μπορείς να συμμετέχεις;</a>
                        <a href="/privacy">Πολιτική Απορρήτου</a>
                        <a href="/home">Αρχική</a>
                        <a href="/contact">Επικοινωνία</a>
                    </nav>
                </div>

                <div className="footer-program-right-block">
                    <img
                        src='/img/logo_programmatos.png'
                        className='footer-program-logo'
                        alt='program logo'
                    />
                </div>
            </div>
            {showAdminNavigation && <Footer/>}
        </>
    )
}
